var map = {
	"./bn.png": 528,
	"./en.png": 529,
	"./es.png": 530,
	"./fa.png": 531,
	"./fr.png": 532,
	"./hi.png": 533,
	"./id.png": 534,
	"./km.png": 535,
	"./ms.png": 536,
	"./my.png": 537,
	"./ne.png": 538,
	"./pt.png": 539,
	"./te.png": 540,
	"./th.png": 541,
	"./ur.png": 542,
	"./vi.png": 543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 527;